"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActionForbidden = void 0;
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var auth = __importStar(require("../helpers/auth"));
var loginSlice_1 = require("../features/login/loginSlice");
var Routes_1 = require("../constants/Routes");
var useActionForbidden = function (cb) {
    var history = react_router_dom_1.useHistory();
    var dispatch = react_redux_1.useDispatch();
    return function () {
        if (auth.requiresVerification()) {
            history.push(Routes_1.Routes.Verify.path);
            return;
        }
        if (auth.isAuthenticated()) {
            cb();
            return;
        }
        dispatch(loginSlice_1.openLoginFormModal({ redirectAfterLogin: true }));
    };
};
exports.useActionForbidden = useActionForbidden;
